import { SUBSCRIPTION_STATUS, SUBSCRIPTION_LICENSE_TYPE } from '../../src/constants/tenantConstants';
var setProperty = function setProperty(key, value) {
    //@ts-ignore
    if (window.clarity) {
        //@ts-ignore
        window.clarity('set', key, value);
    }
};
var claritySetUserProperty = function claritySetUserProperty(key, value) {
    setProperty(key, value);
};
var setClarityUserProperties = function setClarityUserProperties(userData) {
    if (userData) {
        var _userData_tenant, _userData_tenant1;
        var setObj = {};
        setObj['userID'] = userData._id;
        if (userData === null || userData === void 0 ? void 0 : (_userData_tenant = userData.tenant) === null || _userData_tenant === void 0 ? void 0 : _userData_tenant.subscriptionLicenseType) {
            setObj['Subscription License Type'] = userData.tenant.subscriptionLicenseType;
        }
        if ([
            SUBSCRIPTION_STATUS.ACTIVE,
            SUBSCRIPTION_STATUS.FREE
        ].includes(userData.tenant.subscriptionStatus)) {
            setObj['Subscription status'] = userData.tenant.subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE ? 'Paid' : 'Free';
        }
        if ((userData === null || userData === void 0 ? void 0 : (_userData_tenant1 = userData.tenant) === null || _userData_tenant1 === void 0 ? void 0 : _userData_tenant1.subscriptionLicenseType) === SUBSCRIPTION_LICENSE_TYPE.PROFESSIONAL) {
            var _userData_tenant_subscriptionDetails;
            setObj['Professional Subscription Date'] = (_userData_tenant_subscriptionDetails = userData.tenant.subscriptionDetails) === null || _userData_tenant_subscriptionDetails === void 0 ? void 0 : _userData_tenant_subscriptionDetails.startDate;
        }
        Object.keys(setObj).forEach(function(key) {
            claritySetUserProperty(key, setObj[key]);
        });
    }
};
export { claritySetUserProperty, setClarityUserProperties };
